import { NotificationChannel } from './notification-channel.interface';

/**
 * A receiver's complete notification subscription record.
 *
 * The notification API uses this same shape for both the read response and the
 * create and update request bodies, so the service builds it in both
 * directions.
 */
export interface NotificationsAPIResponse {
  /**
   * The delivery channel, matching the receiver type the record was created
   * with.
   */
  notificationType: string;

  /**
   * The receiver this record belongs to: an email address, or an identity
   * reference for a web receiver.
   */
  receiverId: string;

  /**
   * The channels the receiver holds subscriptions on.
   */
  channels: NotificationChannel[];

  /**
   * When the record was last written, as an ISO 8601 timestamp.
   */
  eventDate: string;

  /**
   * The locale to send notifications in, as an IETF language tag.
   */
  clientLocale: string;
}
